import React from 'react';
import { Asset } from '../../../types/asset';
import styled from 'styled-components';

interface PartnerProp {
    title: string;
    logo: Asset;
    summary: string;
    category?: string;
    featured: boolean;
}

const PartnerImageContainer = styled.div`
    @media(min-width: 640px) {
        width: 380px !important;
        height: 246px  !important;
    }
`;

const RichText = styled.div`
    font-size: 1rem !important;
`;

const RichTextLg = styled.div`
    font-size: 1.4rem !important;
`;

export const TechPartner: React.FC<PartnerProp> = ({
    title,
    logo,
    summary,
    category,
    featured,
}) => {
    if (featured) {
        return (
            <div className={'border-t border-b border-black'}>
                <div className={'flex flex-col items-center'}>
                    <div className={'h-32 border-l border-gray-500'}/>
                    <div className={'bg-white border border-gray-500 py-20 mx-8 sm:mx-80 text-center'}>
                        <p className={'uppercase text-xl'}>Featured Partner</p>
                        <img src={logo.url} alt={title} className={'mx-auto'}/>
                        <RichText className="px-6 mt-2 text-xl richtext sm:px-32" dangerouslySetInnerHTML={{__html: summary}}/>
                    </div>
                    <div className={'h-32 border-l border-gray-500'}/>
                </div>
            </div>
        );
    }

    return (
        <div className={'flex flex-col sm:flex-row max-w-5xl mx-auto pt-20 pb-20 px-8'}>
            <PartnerImageContainer
                className={'border border-black bg-white sm:mr-16 flex-none flex w-72 h-48 mx-auto'}
            >
                <img
                    src={logo.url}
                    className={'object-none object-center w-full'}
                    alt={title}
                />
            </PartnerImageContainer>
            <div className={'flex-initial mt-12 sm:mt-0'}>
                <h3 className={'font-bold text-2xl -mb-1'}>{title}</h3>
                <span className={'font-normal text-base leading-none'}>{category}</span>
                <RichText className="mt-6 richtext" dangerouslySetInnerHTML={{__html: summary}} />
            </div>
        </div>
    );

};
